import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function PrivacyPage() {
  useEffect(() => {
    document.title = '隐私政策 - 韩国漫画网';
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-20 pb-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-700 font-medium">隐私政策</span>
          </nav>
          <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-8">隐私政策</h1>
          <div className="prose prose-sm max-w-none text-foreground-700 space-y-6">
            <p>韩国漫画网（以下简称"我们"）深知个人信息对您的重要性，我们将按照法律法规的要求，保护您的个人信息安全。</p>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mt-8 mb-3">1. 信息收集</h2>
            <p>我们仅收集必要的浏览数据用于改善服务质量，不收集任何个人身份信息。您无需注册即可使用本站全部功能。</p>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mt-8 mb-3">2. 信息使用</h2>
            <p>收集的匿名浏览数据仅用于分析网站访问情况、优化用户体验，不会用于任何商业用途或向第三方提供。</p>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mt-8 mb-3">3. Cookie 使用</h2>
            <p>我们使用必要的 Cookie 来维持网站正常运行，如记住您的阅读偏好设置。您可以在浏览器设置中禁用 Cookie。</p>
            <h2 className="text-lg font-heading font-bold text-foreground-950 mt-8 mb-3">4. 联系我们</h2>
            <p>如果您对隐私政策有任何疑问，请通过 hello@szfirstteam.com 与我们联系。</p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}